export const COMPANIES_GLOSSARY = [
  {
    key: 'companies.profile',
    label: 'Porte, perfil e jornada',
    whatIs: 'Três dados do cadastro numa célula: o porte pelo número de funcionários (A a E), o perfil comercial gravado no Master e a etapa da jornada do cliente.',
    purpose: 'Situa a conta antes de ler o uso: compare empresas de porte e perfil parecidos e confira se a jornada gravada combina com a atividade.',
    howGenerated: 'Lidos do retrato noturno mais recente do período: o porte vem do total de funcionários do cadastro; perfil e jornada, do detalhe da empresa no Master. Na exportação viram três colunas.',
    seeAlso: ['common.sizeBand', 'common.segment', 'common.journey'],
  },
  {
    key: 'companies.featuresAdopted',
    label: 'Funcionalidades adotadas',
    whatIs: 'Quantas funcionalidades diferentes do catálogo do PI tiveram pelo menos um evento de uso registrado na empresa nos 30 dias até o último dia fechado do período.',
    purpose: 'Mostra a amplitude do uso: conta que usa poucas funcionalidades depende de um módulo só e tem mais risco; muitas indicam produto enraizado.',
    howGenerated: 'Contadas no fechamento diário a partir dos eventos de cada funcionalidade, na janela móvel de 30 dias que termina no dia de referência, só para empresas do universo ativo.',
    caveat: 'Um evento basta para a funcionalidade contar, e o filtro de papel do usuário não muda este número. A adoção por usuário está no detalhe da empresa.',
  },
  {
    key: 'companies.signal',
    label: 'Sinal',
    whatIs: 'Alerta calculado para a empresa. Hoje o único sinal é "Queda de atividade"; sem sinal, a célula mostra "—".',
    purpose: 'Destaca na lista as contas que pedem contato do time de sucesso do cliente antes de qualquer outra leitura.',
    howGenerated: 'Queda de atividade: ativos em 30 dias no último dia fechado em até 70% do mesmo número no fim do período anterior de mesmo tamanho, com pelo menos 10 ativos antes.',
    seeAlso: ['common.signalDrop', 'filter.signal'],
  },
  {
    key: 'companies.demoReason',
    label: 'Motivo da demonstração',
    whatIs: 'Por que a empresa foi marcada como demonstração: Demonstração nossa, Interna ou teste nosso, Outro (com observação) ou Marcada direto no cadastro, quando a marca não passou pelo Master.',
    purpose: 'Separa demonstrações comerciais de contas internas e de teste, para revisar a marca depois sem depender da memória de quem marcou.',
    howGenerated: 'Vem da última marcação feita no detalhe da empresa (no PI ou no Master), gravada na trilha de alterações do Master e no histórico de demonstração do PI.',
    caveat: 'Empresa que não é de demonstração fica com o motivo vazio.',
    seeAlso: ['common.demo'],
  },
  {
    key: 'companies.demoSince',
    label: 'Demonstração desde',
    whatIs: 'Dia, no horário de Brasília, da última marcação como demonstração. Se a marca foi feita direto no cadastro, é o dia do primeiro retrato noturno que trouxe a marca.',
    purpose: 'Mostra há quanto tempo a empresa está fora dos números, para conferir marcações antigas ou esquecidas.',
    howGenerated: 'Data do último evento de marcação no histórico de demonstração do PI; sem evento, o dia em que começou a sequência atual de retratos noturnos da empresa com a marca.',
    seeAlso: ['common.demo'],
  },
  {
    key: 'companies.demoBy',
    label: 'Marcada por',
    whatIs: 'Nome do usuário do Master que fez a última marcação como demonstração.',
    purpose: 'Diz com quem falar antes de desmarcar uma empresa.',
    howGenerated: 'Gravado junto com a marcação, a partir do login de quem marcou. Fica vazio quando a marca foi feita direto no cadastro, sem passar pelo Master.',
    seeAlso: ['common.demo'],
  },
  {
    key: 'companies.demoSuggestion',
    label: 'Sugestão para revisar',
    whatIs: 'Motivo pelo qual uma empresa ativa, ainda sem a marca, parece nossa: nome com teste, demonstração, homologação, apresentação, demo, mock, MarQ ou Mam Labs, ou âncora dos jobs.',
    purpose: 'Lista para revisão humana: abra o detalhe com "Revisar" e marque só se a empresa for de fato nossa. Nada é marcado sozinho.',
    howGenerated: 'Compara o nome no retrato noturno com os padrões (trechos como "teste" e palavras inteiras como "demo" e "marq") e com a lista fixa de empresas âncora dos jobs, uma por banco.',
    caveat: 'Âncora dos jobs é a empresa que os processos automáticos usam como referência de cada banco. Nome parecido não prova que a empresa é nossa.',
    seeAlso: ['common.demo'],
  },
  {
    key: 'companies.demoCount',
    label: 'Empresas de demonstração fora dos números',
    whatIs: 'Quantas empresas ativas e não excluídas estão marcadas como demonstração e, por isso, ficam fora de todos os números do PI, inclusive do histórico.',
    purpose: 'Mostra o tamanho do que foi tirado dos números; "ver" lista as marcadas para conferir o motivo de cada uma.',
    howGenerated: 'Contagem no retrato noturno mais recente até o fim do período, em todos os bancos e sem o ambiente de Portugal. Busca, porte, perfil e jornada não mudam este número.',
    seeAlso: ['common.demo', 'companies.suggestionCount'],
  },
  {
    key: 'companies.suggestionCount',
    label: 'Sugestões para revisar',
    whatIs: 'Quantas empresas ativas, ainda sem a marca de demonstração, têm nome de teste ou de demonstração ou são âncora dos jobs.',
    purpose: 'Indica o saneamento pendente; "ver" lista as sugestões para revisar uma a uma no detalhe da empresa.',
    howGenerated: 'Mesma regra da coluna "Sugestão para revisar", contada no retrato noturno mais recente até o fim do período, em todos os bancos. Busca, porte, perfil e jornada não mudam este número.',
    seeAlso: ['companies.demoSuggestion'],
  },
  {
    key: 'companies.demoNote',
    label: 'Observação',
    whatIs: 'Texto livre de até 300 caracteres que acompanha a marcação ou a desmarcação da empresa de demonstração.',
    purpose: 'Explica o caso para quem revisar a marca depois. É obrigatória quando o motivo é Outro.',
    howGenerated: 'Gravada com a mudança na trilha de alterações do Master, na nota do funil da empresa e no histórico de demonstração do PI.',
  },
  {
    key: 'companies.plan',
    label: 'Plano',
    whatIs: 'Tipo de plano gravado no cadastro da empresa: Trial, Free, Até 10 ou Acima de 10 funcionários.',
    purpose: 'Situa a conta comercialmente ao ler o uso, por exemplo uma empresa em Free com muitos ativos.',
    howGenerated: 'Lido do campo de plano do cadastro no retrato noturno mais recente da empresa, seja qual for o período escolhido.',
    caveat: 'É o plano de hoje, não o da época do período.',
  },
  {
    key: 'companies.createdAt',
    label: 'Criada em',
    whatIs: 'Dia em que a empresa foi criada no sistema, pelo Master ou pelo cadastro no site.',
    purpose: 'Dá a idade da conta para ler o uso: empresa recém-criada ainda está em implantação.',
    howGenerated: 'Lido da data de criação do cadastro no retrato noturno mais recente da empresa.',
    caveat: 'Não é a data da venda: a venda (D0) está no bloco de ativação.',
  },
  {
    key: 'companies.peerMedian',
    label: 'Mediana dos pares',
    whatIs: 'Active Seats Rate da empresa do meio entre as empresas ativas do mesmo porte: metade fica acima e metade abaixo.',
    purpose: 'Diz se a conta usa mais ou menos que empresas de tamanho parecido, sem que poucas contas muito ativas puxem a média.',
    howGenerated: 'Para cada empresa do universo ativo do mesmo porte com habilitados: ativos habilitados em 30 dias ÷ habilitados, no último dia fechado do período; depois, a mediana.',
    caveat: 'Empresa sem porte no cadastro não tem pares. O porte vem do número de funcionários, não do plano.',
    seeAlso: ['common.activeSeatsRate', 'companies.peerGap'],
  },
  {
    key: 'companies.peerCount',
    label: 'Empresas do mesmo porte',
    whatIs: 'Quantas empresas entraram no cálculo da mediana dos pares: as do universo ativo com o mesmo porte e com pelo menos um usuário habilitado.',
    purpose: 'Diz quão sólida é a comparação: poucas empresas no porte deixam a mediana instável.',
    howGenerated: 'Contadas no retrato noturno mais recente até o fim do período, sem as de demonstração e sem as que têm mais ativos que habilitados.',
    seeAlso: ['companies.peerMedian'],
  },
  {
    key: 'companies.peerGap',
    label: 'Distância da mediana dos pares',
    whatIs: 'Diferença, em pontos percentuais (p.p.), entre o Active Seats Rate da empresa e a mediana dos pares do mesmo porte.',
    purpose: 'Resume a comparação: abaixo da mediana é sinal de baixa adoção para o time de sucesso do cliente investigar.',
    howGenerated: 'Active Seats Rate da empresa menos a mediana dos pares, com uma casa decimal. Diferença menor que 0,05 p.p. aparece como igual.',
    caveat: 'Só aparece quando os dois valores existem.',
    seeAlso: ['companies.peerMedian'],
  },
  {
    key: 'companies.evolution',
    label: 'Evolução',
    whatIs: 'Dois gráficos diários da empresa no período: usuários ativos e em uso, e batidas de ponto registradas.',
    purpose: 'Mostra quando o uso subiu ou caiu, por exemplo depois de uma implantação, de férias coletivas ou de um problema no relógio.',
    howGenerated: 'Lidos dos agregados diários do PI por empresa, no dia local da empresa. Um ponto com o dia ainda aberto aparece como parcial.',
    seeAlso: ['companies.series.activeUsers', 'companies.series.inUseUsers', 'companies.series.punches'],
  },
  {
    key: 'companies.series.date',
    label: 'Data',
    whatIs: 'Dia do ponto da série, no dia local da empresa.',
    purpose: 'Localiza no tempo cada valor da evolução da empresa.',
    howGenerated: 'Um ponto por dia do período que tem agregado diário da empresa; dias sem nenhum registro não aparecem.',
  },
  {
    key: 'companies.series.activeUsers',
    label: 'Usuários ativos',
    whatIs: 'Pessoas distintas da empresa que concluíram pelo menos uma ação de uso real no dia, como bater ponto, pedir ou aprovar ajuste ou férias e assinar espelho ou documento.',
    purpose: 'Mostra o uso real dia a dia; fim de semana e feriado costumam cair.',
    howGenerated: 'Contados no agregado diário do PI a partir dos eventos marcados como uso real no catálogo, no dia local da empresa. Só abrir o sistema não conta.',
    seeAlso: ['companies.series.inUseUsers'],
  },
  {
    key: 'companies.series.inUseUsers',
    label: 'Usuários em uso',
    whatIs: 'Pessoas distintas da empresa que abriram o sistema ou tiveram qualquer evento medido no dia, mesmo sem concluir uma ação de uso real.',
    purpose: 'Comparado com os ativos, mostra quem entra no sistema mas não conclui nenhuma ação.',
    howGenerated: 'Contados no agregado diário do PI a partir das aberturas de sessão e dos eventos do catálogo, no dia local da empresa. O login automático do tablet não conta como abertura.',
    caveat: 'Por regra, é sempre maior ou igual ao número de ativos no mesmo dia.',
    seeAlso: ['companies.series.activeUsers'],
  },
  {
    key: 'companies.series.punches',
    label: 'Batidas registradas',
    whatIs: 'Batidas de ponto gravadas no dia na empresa, por qualquer canal: app, web, tablet, reconhecimento facial, relógio ou integração.',
    purpose: 'Mostra o volume do uso principal do produto e ajuda a achar dia sem batida, que costuma ser problema de coleta ou de equipamento.',
    howGenerated: 'Somadas no agregado diário do PI a partir dos eventos de batida registrada com sucesso (cada batida conta uma vez), no dia local da empresa.',
  },
  {
    key: 'companies.features.name',
    label: 'Funcionalidade',
    whatIs: 'Funcionalidade do catálogo do PI liberada para a empresa no fim do período ou usada por alguém dela no período.',
    purpose: 'Lista o que a conta tem e usa; o nome abre o detalhe da funcionalidade com o mesmo período.',
    howGenerated: 'Catálogo de funcionalidades do PI cruzado com o retrato das funcionalidades liberadas na empresa e com os eventos de uso do período.',
    seeAlso: ['companies.features.adoption'],
  },
  {
    key: 'companies.features.module',
    label: 'Módulo',
    whatIs: 'Área do produto a que a funcionalidade pertence no catálogo de eventos do PI, como Controle de Jornada ou Departamento Pessoal.',
    purpose: 'Agrupa as funcionalidades para ver em que áreas do produto a conta está.',
    howGenerated: 'Vem do catálogo de funcionalidades do PI, o mesmo usado pelo filtro de módulo.',
  },
  {
    key: 'companies.features.users',
    label: 'Usuários',
    whatIs: 'Quantos usuários elegíveis usaram a funcionalidade no período, de quantos elegíveis a empresa tem (por exemplo, "10 de 40").',
    purpose: 'Mostra o tamanho real do uso por trás da porcentagem de adoção.',
    howGenerated: 'Usaram: elegíveis com pelo menos uma ação bem-sucedida no período. Elegíveis: usuários habilitados hoje com um papel que usa a funcionalidade. Na exportação viram duas colunas.',
    seeAlso: ['companies.features.adoptingUsers', 'companies.features.eligibleUsers'],
  },
  {
    key: 'companies.features.adoptingUsers',
    label: 'Usuários que usaram',
    whatIs: 'Usuários elegíveis da empresa com pelo menos uma ação bem-sucedida da funcionalidade no período.',
    purpose: 'É o numerador da adoção: quem de fato usa a funcionalidade na conta.',
    howGenerated: 'Pessoas distintas nos agregados diários de uso por funcionalidade do período, contadas só se hoje estão habilitadas e têm um papel que usa a funcionalidade.',
    seeAlso: ['companies.features.adoption'],
  },
  {
    key: 'companies.features.eligibleUsers',
    label: 'Usuários elegíveis',
    whatIs: 'Usuários habilitados da empresa com um papel (funcionário, gestor, admin ou contador) que pode usar a funcionalidade.',
    purpose: 'É o denominador da adoção: quem poderia usar.',
    howGenerated: 'Contados no cadastro de usuários do retrato mais recente, cruzando o papel de cada um com os papéis aceitos pela funcionalidade no catálogo.',
    caveat: 'É a base de hoje, não a do início do período.',
    seeAlso: ['companies.features.adoption'],
  },
  {
    key: 'companies.features.adoption',
    label: 'Adoção',
    whatIs: 'Parte dos usuários elegíveis da empresa que usou a funcionalidade no período, em porcentagem.',
    purpose: 'Compara funcionalidades dentro da conta: adoção baixa numa funcionalidade liberada é oportunidade de treinamento ou de ativação.',
    howGenerated: 'Usuários que usaram ÷ usuários elegíveis × 100. Sem evento medido sai "Sem medição"; desligada sai "Não habilitada"; sem papel aplicável, "Sem elegíveis"; sem uso, "Sem uso".',
    caveat: 'É por empresa e por período inteiro; não é a adoção de 30 dias da tela de Funcionalidades.',
    seeAlso: ['companies.features.adoptingUsers', 'companies.features.eligibleUsers'],
  },
  {
    key: 'companies.operations.label',
    label: 'Operação',
    whatIs: 'Funcionalidade da empresa com pelo menos uma ação concluída ou com falha no período, tratada como operação.',
    purpose: 'Mostra quanto cada funcionalidade foi executada na conta e com que sucesso.',
    howGenerated: 'Agregado por funcionalidade a partir dos eventos de uso por usuário e dia no período, em ordem decrescente de volume.',
    caveat: 'Aqui a falha não é separada em funcional e técnica, ao contrário da tela de Operações.',
  },
  {
    key: 'companies.operations.attempts',
    label: 'Tentativas',
    whatIs: 'Ações concluídas mais ações com falha da funcionalidade na empresa, no período.',
    purpose: 'É a base da taxa de sucesso.',
    howGenerated: 'Soma dos sucessos e das falhas nos agregados diários por usuário. Só aparece onde a falha da funcionalidade é registrada.',
    caveat: 'Como a falha não é separada em funcional e técnica no agregado por empresa, esta coluna aparece como "—" e só os sucessos são mostrados.',
    seeAlso: ['companies.operations.success'],
  },
  {
    key: 'companies.operations.success',
    label: 'Sucessos',
    whatIs: 'Ações da funcionalidade concluídas com sucesso na empresa, no período.',
    purpose: 'Mostra o volume executado na conta, por exemplo quantos fechamentos ou exportações deram certo.',
    howGenerated: 'Soma dos eventos de sucesso da funcionalidade nos agregados diários por usuário da empresa, no dia local dela.',
  },
  {
    key: 'companies.operations.businessFail',
    label: 'Falha funcional',
    whatIs: 'Ações recusadas por regra de negócio, como período fechado ou falta de permissão.',
    purpose: 'Separa erro de uso de erro do sistema.',
    howGenerated: 'No agregado por empresa a falha não é separada por tipo, então a coluna aparece como "—". A separação está na tela de Operações.',
    seeAlso: ['companies.operations.technicalFail'],
  },
  {
    key: 'companies.operations.technicalFail',
    label: 'Falha técnica',
    whatIs: 'Ações que falharam por erro do sistema ou de infraestrutura.',
    purpose: 'Aponta problema técnico que atinge a conta.',
    howGenerated: 'No agregado por empresa a falha não é separada por tipo, então a coluna aparece como "—". A separação está na tela de Operações.',
    seeAlso: ['companies.operations.businessFail'],
  },
  {
    key: 'companies.operations.successRate',
    label: 'Taxa de sucesso',
    whatIs: 'Parte das tentativas da funcionalidade na empresa que terminou bem, em porcentagem.',
    purpose: 'Taxa baixa numa conta indica erro de uso ou problema técnico que vale investigar com o cliente.',
    howGenerated: 'Sucessos ÷ (sucessos + falhas) × 100 no período, onde a falha é registrada. Onde não é, a taxa sai como "n/d" e fica só o volume de sucessos.',
    seeAlso: ['companies.operations.success'],
  },
  {
    key: 'companies.operations.note',
    label: 'Observação',
    whatIs: 'Aviso sobre como a operação foi medida na empresa, como "falhas sem separação funcional ou técnica no agregado por empresa".',
    purpose: 'Evita ler a taxa ou as falhas de um jeito que a medição não permite.',
    howGenerated: 'Texto do PI para cada operação: um quando a falha é registrada e outro quando só a conclusão é medida.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/companies.js